// REACT
import React, {
	useContext,
	RefObject,
	useRef,
	CSSProperties,
	useEffect,
	Dispatch,
	SetStateAction,
	useState,
} from 'react'
import { Link } from 'react-router-dom'

// ESTILOS
import Styles from './Hotel.module.css'

// IMAGENES
import img_1 from 'Assets/Hotel/inguat-sello-q.jpg'
import img_2 from 'Assets/Hotel/siccs.jpg'
import img_3 from 'Assets/Hotel/biosphere-certified.jpg'
import img_4 from 'Assets/Hotel/codigo-etico-omt.jpg'
import h_1 from 'Assets/Gallery/016.jpg'
import h_2 from 'Assets/Gallery/017.jpg'
import h_3 from 'Assets/Gallery/018.jpg'
import icon_1 from 'Assets/Rooms/bed.svg'
import icon_2 from 'Assets/Rooms/photo@2x.png'
import icon_3 from 'Assets/Rooms/calendar.svg'

// CONTEXTO
import MainContext from 'Context/MainContext'

// COMPONENTES
import ShowBook from 'Components/showBook/ShowBook'
import Carousel from 'Components/Carousel/Carousel'

// ESTADO
interface HotelState {
	update: boolean
}

// GLOBALES
const differedSrc: string =
	'https://firebasestorage.googleapis.com/v0/b/hotelbbvdda.appspot.com/o/gallery%2F08.jpg?alt=media&token=494703fc-80df-466b-b3d3-3d511ccb4cac'

// CERTIFICACIONES
const imgs = [
	'https://firebasestorage.googleapis.com/v0/b/hotelbbvdda.appspot.com/o/gallery%2F016.jpg?alt=media&token=752a76c0-50b9-4684-bd8e-66c1e2ca9484',
	'https://firebasestorage.googleapis.com/v0/b/hotelbbvdda.appspot.com/o/gallery%2F017.jpg?alt=media&token=f5ea0e10-9ab1-437e-acf8-ee447b25c0d2',
	'https://firebasestorage.googleapis.com/v0/b/hotelbbvdda.appspot.com/o/gallery%2F018.jpg?alt=media&token=994e9c72-dd85-4503-9626-74f12b2c62d2',
]
const differedImgs = [h_1, h_2, h_3]

// ESTADO
const DefState: HotelState = {
	update: false,
}

const Hotel: React.FC = () => {
	// CONTEXTO
	const { hotel } = useContext(MainContext).lang
	const { rooms_1 } = useContext(MainContext).lang

	// ESTADO
	const [state, setState]: [HotelState, Dispatch<SetStateAction<HotelState>>] = useState(DefState)

	// CLASSES
	const classCar: CSSProperties = { width: '100%', height: '100%', position: 'relative' }

	// REFERENCIAS
	const introRef: RefObject<HTMLDivElement> = useRef(null)
	const imgRef: RefObject<HTMLImageElement> = useRef(null)

	// ACTIVADOR
	useEffect(() => {
		const addImages = () => {
			// SCROLL
			const scroll: number = window.scrollY

			// IMAGENES
			if (scroll > 50 && imgRef.current) {
				imgRef.current.src = differedSrc
				setState({ update: true })
			}
		}

		// AGREGAR EVENTO
		window.addEventListener('scroll', addImages)

		// QUITAR EVENTO
		return () => window.removeEventListener('scroll', addImages)
	}, [])

	return (
		<>
			<section className={`${Styles.container} ${Styles.page2} page`} ref={introRef}>
				<div className={Styles.contInfo}>
					<div className={Styles.contTitle}>
						<h1>{hotel.title}</h1>
						<p>{hotel.desc}</p>
					</div>
					<div className={Styles.contInfo2}>
						<div className={Styles.contCharacter}>H</div>
						<p>{hotel.text}</p>
					</div>
					<p>{hotel.text_1}</p>
					<p>{hotel.text_2}</p>
				</div>
			</section>
			<section className={Styles.container2}>
				<div className={Styles.contImgs}>
					{state.update ? (
						<Carousel update imgs={imgs} time={10000} class1={classCar} class2={classCar} />
					) : (
						<Carousel imgs={differedImgs} class1={classCar} class2={classCar} />
					)}
				</div>
				<div className={Styles.contCert}>
					<div className={Styles.contCertInfo}>
						<h1>{hotel.records.title}</h1>
						<div className={Styles.certInfoPoliticas}>
							<p>{hotel.txt_1}</p>
							<ShowBook
								name={hotel.txt_2}
								style={{
									color: 'gold',
									marginLeft: '5px',
								}}
								type='sosten'
							/>
						</div>
					</div>
					<div className={Styles.contImgCert}>
						<img src={img_1} alt='Inguat Banner' />
						<img src={img_2} alt='Siccs Banner' />
						<img src={img_3} alt='Biosphere Banner' />
						<img src={img_4} alt='Codigo Banner' />
					</div>
				</div>
			</section>
			<section className={`${Styles.containerRoom} page`}>
				<div className={Styles.contRoom}>
					<div className={Styles.contText2}>
						<p className={Styles.text}>{rooms_1.text_1}</p>
						<h1>{rooms_1.text_2}</h1>
						<p>{rooms_1.text_3}</p>
					</div>
					<div className={Styles.contRoomDiv}>
						<div className={Styles.roomImg}>
							<img src='' alt='Habitación' ref={imgRef} />
						</div>
						<div className={Styles.contRoomData}>
							<Link to='/habitaciones'>
								<div className={Styles.roomData}>
									<div className={Styles.roomDataSec}>
										<img src={icon_1} alt='icono' width='60px' />
										<h1>{rooms_1.hab}</h1>
									</div>
									<div className={Styles.roomDataBottom} />
								</div>
							</Link>
							<Link to='/galeria'>
								<div className={Styles.roomData}>
									<div className={Styles.roomDataSec}>
										<img src={icon_2} alt='icono' width='60px' />
										<h1>{rooms_1.gal}</h1>
									</div>
									<div className={Styles.roomDataBottom} />
								</div>
							</Link>
							<Link to='/reservaciones'>
								<div className={Styles.roomData}>
									<div
										className={Styles.roomDataSec}
										style={{ paddingBottom: '3px', marginBottom: '3px' }}>
										<img src={icon_3} alt='icono' width='60px' />
										<h1>{rooms_1.res}</h1>
									</div>
									<div className={Styles.roomDataBottom} />
								</div>
							</Link>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default Hotel
